import React from 'react';
import PropTypes from 'prop-types';
import {Field, reduxForm} from 'redux-form';
import i18n from "i18next";
import RaisedButton from 'material-ui/RaisedButton';
import styles from '../../../../styles/styles';
import style from './MediaTypeForm.css';
import {renderTextField} from "../../../../services/form";
import {SketchPicker} from 'react-color';
import withTranslation from '../../../../hoc/withTranslation';

const validate = values => {
    const errors = {};
    const requiredFields = [
        'name'
    ];

    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = i18n.t('generic.required');
        }
    });

    const color = values['color'];
    if (color && /(^#[0-9a-fA-F]{6}$)|(^#[0-9a-fA-F]{3}$)/i.test(color) === false) {
        errors['color'] = i18n.t('page_app.wrong_primary_color');
    }

    return errors;
};

export class MediaTypeForm extends React.Component {

    static propTypes = {
        onFormReset: PropTypes.func
    };

    state = {
        displayColorPicker: false,
        color: undefined
    };

    // Handlers

    handleColorChangedFromField = (event) => {
        this.setState({color: event.target.value})
    };

    handleClick = () => {
        this.setState({displayColorPicker: !this.state.displayColorPicker})
    };

    handleClose = () => {
        this.setState({displayColorPicker: false})
    };

    handleChange = (color) => {
        this.props.change("color", color.hex)
    };

    // Render

    render() {
        const {handleSubmit, pristine, reset, submitting} = this.props;

        return (
            <form onSubmit={handleSubmit}>
                <div>
                    <Field
                        id="name"
                        name="name"
                        component={renderTextField}
                        label={this.props.t("generic.name")}
                        fullWidth={true}
                    />
                    <Field
                        id="color"
                        name="color"
                        component={renderTextField}
                        label={this.props.t("generic.color")}
                        fullWidth={true}
                        onChange={this.handleColorChangedFromField}
                        onClick={this.handleClick}
                    />
                    <Field
                        id="link"
                        name="link"
                        label={this.props.t('settings_page.type_link')}
                        component={renderTextField}
                        fullWidth={true}
                    />
                    {this.state.displayColorPicker && (
                        <div style={style.popover}>
                            <div style={style.cover} onClick={this.handleClose} />
                            <SketchPicker color={this.state.color} onChange={this.handleChange} />
                        </div>
                    )}
                    {/*<BlockPicker onChange={this.handleChange}/>*/}
                </div>
                <div style={styles.formButtons}>
                    <RaisedButton
                        style={styles.formButton}
                        label={this.props.t("generic.save")}
                        disabled={pristine || submitting}
                        type="submit"
                        primary={true}
                    />
                    <RaisedButton
                        style={styles.formButton}
                        label={this.props.t("generic.reset")}
                        type="button"
                        disabled={pristine || submitting}
                        onClick={() => {
                            reset();
                            if (this.props.onFormReset) {
                                this.props.onFormReset();
                            }
                        }}
                    />
                </div>
            </form>
        );
    }
}

export default reduxForm({
    form: 'editMediaType',
    validate
})(withTranslation(MediaTypeForm));



// WEBPACK FOOTER //
// src/components/media/MediaType/MediaTypeForm/MediaTypeForm.js